import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { MultilineText } from '@common/components/MultilineText';

import { Icon } from '@components/Icon';

import { IconBrandLogotype } from '@icons';

import {
	EBrandFileName,
	EBrandImage,
	EBrandMenuItem,
} from '../../enums';
import { BrandDownloadPanel } from '../BrandDownloadPanel';
import { BrandMenu } from '../BrandMenu';

import { IBrandMainScreenProps, IBrandMainScreenState } from './types';

import * as s from './BrandMainScreen.scss';

@Translate('common.containers.Brand.components.BrandMainScreen')
export class BrandMainScreen extends React.Component<IBrandMainScreenProps, IBrandMainScreenState> {

	shouldComponentUpdate(): boolean {
		return false;
	}

	render() {
		const {
			isMobile,
			brand,
			urls: {
				brandDownload,
				imagePath,
			},
			className,
			lastMenuItemRef,
			onMenuItemSelect,
			onDownloadAllButtonClick,
		} = this.props;

		const hideThresholds = isMobile
			? {
				[EBrandMenuItem.BLOCK]: 375,
				[EBrandMenuItem.BADGE]: 375,
				[EBrandMenuItem.APP_ICON]: 375,
			}
			: null;

		return (
			<div className={cn(s.block, className)} style={{
				backgroundImage: `url(${imagePath}/${EBrandImage.BRAND_MAN}.svg)`,
			}}>
				<div className={s.column}>
					<Icon glyph={IconBrandLogotype} className={s.logo} />

					<BrandMenu
						isMobile={isMobile}
						lastMenuItemRef={lastMenuItemRef}
						className={s.menu}
						hideThresholds={hideThresholds}
						onSelect={onMenuItemSelect}
					/>
				</div>

				<div className={s.column}>
					<BrandDownloadPanel
						linkUrl={`${brandDownload}/${EBrandFileName.ALL}.zip`}
						fileSize={brand.fileSizes.all}
						classNames={{
							block: s.downloadPanel,
							button: s.downloadButton,
							buttonActive: s.downloadButtonActive,
							fileSize: s.downloadFileSize,
						}}
						title={this.t('downloadAllMaterials')}
						onClick={onDownloadAllButtonClick}
					/>

					{!isMobile &&
						<div className={s.notice}>
							{this.t('registeredTrademark')}
						</div>
					}

					<div className={s.notice}>
						<MultilineText text={this.t('trademarkPermission')}/>
					</div>
				</div>
			</div>
		);
	}

}
